export const MAAS_UI_ID = "maas-ui";
export const MOBILE_VIEW_MAX_WIDTH = 620;
